import { combineReducers } from 'redux';
import app from './app/reducer';
import * as appSagas from './sagas';

export default combineReducers({
  app
});

export { appSagas };
